import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/NEWTEC_FUNDO_2.jpg'


const _withScopeId = n => (_pushScopeId("data-v-45ce61a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "contact-image",
  class: "new-image-background-login"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_ForgotPassword)
  ], 64))
}